import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlay,
  faCirclePause,
  faCircleInfo,
  faBriefcase,
  faLaptopCode,
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const Box = styled.div`
  position: fixed;
  color: white;
  z-index: 10;
  justify-content: center;
  align-items: center;
  right: 0;
  bottom: 3.5rem;
`;
const MenuBtn = styled.div`
  width: 250px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 425px) {
    margin-right: -1rem;
    margin-top: -0.5rem;
  }
`;

const Item = styled.li`
  display: flex;
  visibility: hidden;
  position: absolute;
  left: 10%;
  top: -30px;
  list-style: none;
  transform-origin: 100px;
  transition: 0.5s;
  transition-delay: calc(0.1s var (--i));
  transform: rotate(0deg) translateX(80px);

  ${MenuBtn}.active & {
    visibility: visible;
    transform: rotate(calc(150deg / 3 * var(--i)));
  }
  @media (max-width: 425px) {
    left: 18%;
    transform-origin: 80px;
  }
  @media (max-width: 768px) {
    left: 14%;
    top: -35px;
    transform-origin: 90px;
    ${MenuBtn}.active & {
      visibility: visible;
      transform: rotate(calc(-150deg / 3 * var(--i)));
    }
  }
`;

const Toggle = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;

  transition: transform 1.25s;

  ${MenuBtn}.active & {
    animation: none;
  }
`;

const ListItem = styled.div`
  ${MenuBtn}.active & {
    transform: rotate(calc(150deg / -3 * var(--i)));
  }

  @media (max-width: 768px) {
    ${MenuBtn}.active & {
      transform: rotate(calc(150deg / 3 * var(--i)));
    }
  }
`;

const Menu = () => {
  const [isActive, setActive] = useState("false");
  const [isShow, setShow] = useState("false");

  const handleToggle = () => {
    setActive(!isActive);
    setShow(!isShow);
  };

  return (
    <Box className="z-30 md:z-0 md:-mr-10 md:my-20 md:top-0 md:right-0">
      <MenuBtn className={isActive ? "" : "active"}>
        <Toggle className="animate-bounce">
          <div onClick={handleToggle} className="text-6xl sm:text-5xl">
            <FontAwesomeIcon
              className={isShow ? "visible" : "hidden"}
              icon={faCirclePlay}
            />
            <FontAwesomeIcon
              className={isShow ? "hidden" : "visible"}
              icon={faCirclePause}
            />
          </div>
        </Toggle>

        <Item className="text-4xl sm:text-3xl" style={{ "--i": 0 }}>
          <ListItem className="flex flex-col items-center">
            <span className="text-xs"> Work</span>
            <NavLink to="/work">
              <FontAwesomeIcon icon={faBriefcase} />
            </NavLink>
          </ListItem>
        </Item>
        <Item className="text-4xl sm:text-3xl" style={{ "--i": 1 }}>
          <ListItem className="flex flex-col items-center">
            <span className="text-xs"> Skills</span>
            <NavLink to="/skill">
              <FontAwesomeIcon icon={faLaptopCode} />
            </NavLink>
          </ListItem>
        </Item>
        <Item className="text-4xl sm:text-3xl" style={{ "--i": 2 }}>
          <ListItem className="flex flex-col items-center">
            <span className="text-xs"> Info</span>
            <NavLink to="/about">
              <FontAwesomeIcon icon={faCircleInfo} />
            </NavLink>
          </ListItem>
        </Item>
      </MenuBtn>
    </Box>
  );
};

export default Menu;
